//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    data: function data() {
        return {
            lastSearchText: '',
            lastSearchType: ''
        };
    },
    created: function created() {
        if (process.client) {
            this.lastSearchText = customSessionStorage.getItem('lastSearchText');
            this.lastSearchType = customSessionStorage.getItem('lastSearchType');
        }
    },
    mounted: function mounted() {
        setTimeout(function () {
            this.redirect();
        }.bind(this), 5000);
    },

    computed: {
        lang: function lang() {
            return this.$root._route.params.lang;
        }
    },
    methods: {
        redirect: function redirect() {
            if (this.lastSearchText && this.lastSearchType) {
                this.$router.push({ name: 'lang-search-results-type-search-loading', params: { lang: this.lang, type: this.lastSearchType, search: this.lastSearchText } });
            } else {
                this.$router.push({ name: 'lang', params: { lang: this.lang } });
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/successful-signup.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/successful-signup.vue
// module chunks = 47